import { styled } from "baseui";

export const Divider = styled("hr", ({ $theme }) => ({
  ...$theme.borders.border200,
  borderBottom: "none",
  width: "100%",
  marginBottom: $theme.sizing.scale200,
}));
